// extracted by mini-css-extract-plugin
export var banner = "_t3-0";
export var settingRow = "_t3-2";
export var titleIcon = "_t3-1";